<template>
    <Wait_Skeleton v-if="!IsWait" />

    <Card v-if="IsWait" class="">
        <template #content>
            <div class="grid flex flex-wrap align-items-center justify-content-center">
                <div class="w-min md:w-max col-12 md-12 lg-12 ">
                </div>

                <div class="w-min md:w-max col-12 md-6 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">
                            <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title ">Danışan
                                Sayısı</h4>
                            <span class="hind-font caption-12 c-dashboardInfo__count">{{ DanisanSayi }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-min md:w-max col-12 md-6 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">
                            <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title ">Diyet Sayısı</h4>
                            <span class="hind-font caption-12 c-dashboardInfo__count">{{ DiyetSayi }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-min md:w-max col-12 md-12 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">
                            <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title ">Tarif
                                Sayısı</h4>
                            <span class="hind-font caption-12 c-dashboardInfo__count">{{ TarifSayi }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
export default {
    data() {
        return {
            DanisanSayi: "0",
            DiyetSayi: "0",
            TarifSayi: "0",
            IsWait: false
        };
    },
    methods: {
        _GetDanisanSayi() {
            GlobalServis.GlobalServis("GET", "GetDanisanSayi", "").then((res) => {
                if (res.status == 200) {
                    this.DanisanSayi = res.data[0].DanisanSayi;
                    this.IsWait = true;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetDiyetSayi() {
            GlobalServis.GlobalServis("GET", "GetDiyetSayi", "").then((res) => {
                if (res.status == 200) {
                    this.DiyetSayi = res.data[0].DiyetSayi;
                    this.IsWait = true;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
        _GetTarifSayi() {
            GlobalServis.GlobalServis("GET", "GetTarifSayi", "").then((res) => {
                if (res.status == 200) {
                    this.TarifSayi = res.data[0].TarifSayi;
                    this.IsWait = true;
                } else if (res.status == 400) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Önemli bir hata meydana geldi",
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bilinmeyen bir hata meydana geldi",
                        life: 3000,
                    });
                }
            });
        },
    },
    created() {
        this._GetDanisanSayi();
        this._GetDiyetSayi();
        this._GetTarifSayi();
    },
    components: {
    },
};
</script>

<style scoped>
.c-dashboardInfo .wrap {
    background: #ffffff;
    box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
    border: 0.5px solid #EFD1FF;
    text-align: center;
    position: relative;
    overflow: hidden;
    padding: 10px 10px;
    height: 100%;
    width: 20vw;
}

.c-dashboardInfo__title {
    color: #6c6c6c;
    font-size: 1.18em;
}

.c-dashboardInfo__count {
    font-weight: 600;
    font-size: 2em;
    line-height: 25px;
    color: #323c43;
}

.c-dashboardInfo .wrap:after {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    content: "";
}

.c-dashboardInfo .wrap:after {
    background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}
</style>